<template>
    <canvas ref="canvas" class="block"></canvas>
</template>

<script>
import { renderQrToCanvas } from "@/common/lib/qr";

export default {
    name: "QrViewer",
    props: {
        value: {
            type: String,
            required: true
        },
        size: {
            type: Number,
            default: 256
        }
    },
    watch: {
        value() {
            this.render();
        },
        size() {
            this.render();
        }
    },
    mounted() {
        this.render();
    },
    methods: {
        async render() {
            if (!this.value) return;
            await renderQrToCanvas(this.$refs.canvas, this.value, this.size);
        }
    }
};
</script>
